module.exports = __webpack_public_path__ + "static/media/Sharp-LQ104S1LG75-Mechanical-Drawing.cdbd38c9.gif";